module.exports = __webpack_public_path__ + "static/media/gradient-peach.6d6e1767.svg";